import React, { useEffect, useState } from 'react';

const Packagediscount = () => {
  const [slots, setSlots] = useState([{ amount: '', discount: '', _id: null, isRemove: false }]);
  const [GetData, setGetData] = useState([]);
  const [UpdateId, setUpdateId] = useState("");
  const [message, setMessage] = useState(null); // New state for messages
  const [messageType, setMessageType] = useState(null); // "success" or "error"

  const AddANDUpdateAPi = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify({
        data: slots
      });

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow"
      };

      fetch("https://api.experts4u.in/package/discount", requestOptions)
        .then((response) => response.text())
        .then((result) => {
          console.log(result);
          setMessage("Data successfully submitted!"); // Set success message
          setMessageType("success");
        })
        .catch((error) => {
          console.error(error);
          setMessage("An error occurred while submitting the data."); // Set error message
          setMessageType("error");
        });
    } catch (error) {
      console.log(error);
      setMessage("An unexpected error occurred."); // Set error message
      setMessageType("error");
    }
  };

  const GetDtata = async () => {
    try {
      const requestOptions = {
        method: "GET",
        redirect: "follow"
      };

      fetch("https://api.experts4u.in/package/discount", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          setGetData(result.data);
          setSlots(result.data);
        })
        .catch((error) => console.error(error));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetDtata();
  }, []);

  const addNewSlot = () => {
    const hasEmptyFields = slots.some((slot) => slot.amount === '' || slot.discount === '');
    if (!hasEmptyFields) {
      setSlots([...slots, { amount: '', discount: '', _id: null, isRemove: false }]);
    }
  };

  const isAddButtonDisabled = slots.some((slot) => slot.amount === '' || slot.discount === '');

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-md-8">
          <div className="card p-4 shadow-sm">
            <div className="card-body">
              <h2 className="text-center mb-4">Package Discount</h2>
              <div style={{ display: 'flex', justifyContent: 'end' }}>
                <button
                  className={`btn ${isAddButtonDisabled ? 'btn-secondary' : 'btn-primary'} mb-2`}
                  onClick={addNewSlot}
                  disabled={isAddButtonDisabled}
                >
                  Add New Slot +
                </button>
              </div>

              {slots.map((slot, index) => (
                !slot.isRemove && ( 
                  <div className="row mb-3" key={index}>
                    <div className="col-5">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Amount"
                        value={slot.amount}
                        onChange={(e) => {
                          const updatedSlots = [...slots];
                          updatedSlots[index].amount = e.target.value;
                          setSlots(updatedSlots);
                        }}
                      />
                    </div>
                    <div className="col-5">
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Package Discount"
                        value={slot.discount}
                        onChange={(e) => {
                          const updatedSlots = [...slots];
                          updatedSlots[index].discount = e.target.value;
                          updatedSlots[index]._id = slot._id;
                          setSlots(updatedSlots);
                        }}
                      />
                    </div>
                    <div className="col-2">
                      <button
                        className={`btn ${slots.length > 1 ? 'btn-danger' : 'btn-secondary'}`}
                        disabled={slots.length === 1}
                        onClick={() => {
                          const updatedSlots = [...slots];
                          updatedSlots[index].isRemove = true;
                          setSlots(updatedSlots); // Update state
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  </div>
                )
              ))}

              <div className="text-center" onClick={AddANDUpdateAPi}>
                <button className={`btn ${isAddButtonDisabled ? 'btn-secondary' : 'btn-primary'}`} disabled={isAddButtonDisabled}>
                  Submit
                </button>
              </div>

              {/* Display success or error message */}
              {message && (
                <div className={`alert mt-3 ${messageType === "success" ? "alert-success" : "alert-danger"}`} role="alert">
                  {message}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Packagediscount;
